const benchmark_score = {
    category1: {
        '1. 인권 및 노동': {
            avg: 88.9,
            tier_avg: {
                'HD_DOM_HQ_25': null,
                'HD_DOM_PROD_25': null,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': null,
                'HD_OV_COMM_PROD_25': null,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        },
        '2. 윤리': {
            avg: 81.0,
            tier_avg: {
                'HD_DOM_HQ_25': null,
                'HD_DOM_PROD_25': null,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': null,
                'HD_OV_COMM_PROD_25': null,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        }
    },
    category2: {
        '1.2. 인권경영 시스템': {
            avg: 83.8,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 84.9,
                'HD_OV_PROD_25': 91.0,
                'HD_OV_COMM_PROD_25': 90.5,
                'HD_OV_RI_25': 77.8,
                'HD_OV_SALES_25': 78.8
            }
        },
        '1.3. 인권 리스크 관리': {
            avg: 90.7,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 95.2,
                'HD_OV_PROD_25': 93.1,
                'HD_OV_COMM_PROD_25': 95.2,
                'HD_OV_RI_25': 81.4,
                'HD_OV_SALES_25': 88.3
            }
        },
        '1.4. 근로환경 개선': {
            avg: 84.5,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 85.1,
                'HD_OV_PROD_25': 92.4,
                'HD_OV_COMM_PROD_25': 82.2,
                'HD_OV_RI_25': 75.6,
                'HD_OV_SALES_25': 80.0
            }
        },
        '1.5. 공급망 인권/노동 관리': {
            avg: 96.5,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': 93.8,
                'HD_OV_COMM_PROD_25': 66.7,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        },
        '1.6. 생활환경 인권 관리': {
            avg: 94.8,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 95.7,
                'HD_OV_COMM_PROD_25': 95.2,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 100
            }
        },
        '2.1. 윤리 경영 시스템': {
            avg: 80.8,
            tier_avg: {
                'HD_DOM_HQ_25': 90,
                'HD_DOM_PROD_25': 90,
                'HD_DOM_RI_25': 90,
                'HD_OV_HQ_25': 67.5,
                'HD_OV_PROD_25': 89,
                'HD_OV_COMM_PROD_25': 80,
                'HD_OV_RI_25': 49.5,
                'HD_OV_SALES_25': 80
            }
        }
    },
    category3: {
        '1.2.1. 인권/노동 정책 및 관리 시스템': {
            avg: 82.1,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 75,
                'HD_OV_PROD_25': 97.5,
                'HD_OV_COMM_PROD_25': 83.3,
                'HD_OV_RI_25': 60,
                'HD_OV_SALES_25': 74.6
            }
        },
        '1.2.2. 근로 조건의 정의': {
            avg: 89.7,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 96.7,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 90,
                'HD_OV_SALES_25': 84.2
            }
        },
        '1.2.3. 근로시간 관리': {
            avg: 92.6,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 88.9,
                'HD_OV_PROD_25': 96.7,
                'HD_OV_COMM_PROD_25': 88.9,
                'HD_OV_RI_25': 93.3,
                'HD_OV_SALES_25': 89.5
            }
        },
        '1.2.4. 임금 지급': {
            avg: 77.5,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 88.9,
                'HD_OV_PROD_25': 76.7,
                'HD_OV_COMM_PROD_25': 88.9,
                'HD_OV_RI_25': 73.3,
                'HD_OV_SALES_25': 75.4
            }
        },
        '1.2.5. 사내도급 근로자 인권 관리': {
            avg: 65.6,
            tier_avg: {
                'HD_DOM_HQ_25': null,
                'HD_DOM_PROD_25': null,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': 0,
                'HD_OV_PROD_25': 77.8,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 75,
                'HD_OV_SALES_25': 53.3
            }
        },
        '1.3.1. 비인도적 행위 금지': {
            avg: 81.5,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 88.9,
                'HD_OV_PROD_25': 86.7,
                'HD_OV_COMM_PROD_25': 88.9,
                'HD_OV_RI_25': 66.7,
                'HD_OV_SALES_25': 75.4
            }
        },
        '1.3.2. 공정한 채용': {
            avg: 80,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 83.3,
                'HD_OV_PROD_25': 85,
                'HD_OV_COMM_PROD_25': 83.3,
                'HD_OV_RI_25': 80,
                'HD_OV_SALES_25': 71.1
            }
        },
        '1.3.3. 아동노동 금지': {
            avg: 94.1,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 97.5,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 86.7,
                'HD_OV_SALES_25': 94.7
            }
        },
        '1.3.4. 강제노동 금지': {
            avg: 96.7,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 96.7,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 86.7,
                'HD_OV_SALES_25': 97.4
            }
        },
        '1.4.1. 노사 커뮤니케이션': {
            avg: 77.8,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 66.7,
                'HD_OV_PROD_25': 85,
                'HD_OV_COMM_PROD_25': 83.3,
                'HD_OV_RI_25': 60,
                'HD_OV_SALES_25': 73.7
            }
        },
        '1.4.2. 근로자 역량 강화 지원': {
            avg: 93.3,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 100,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 84.2
            }
        },
        '1.4.3. 근로자 출산 및 육아 지원': {
            avg: 100,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 100,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 100
            }
        },
        '1.4.4. 시설 위생 관리': {
            avg: 95.6,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 100,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 89.5
            }
        },
        '1.4.5. 결사 및 단체 교섭의 자유': {
            avg: 50,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 0,
                'HD_OV_PROD_25': 85.7,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 13.3
            }
        },
        '1.4.6. 고충처리 매커니즘': {
            avg: 86.9,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 66.7,
                'HD_OV_PROD_25': 92,
                'HD_OV_COMM_PROD_25': 53.3,
                'HD_OV_RI_25': 67,
                'HD_OV_SALES_25': 88.2
            }
        },
        '1.5.1. 협력사 행동규범': {
            avg: 94.1,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': 86.7,
                'HD_OV_COMM_PROD_25': 66.7,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        },
        '1.5.2. 공급망 리스크 관리': {
            avg: 97.5,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': null,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': 96.3,
                'HD_OV_COMM_PROD_25': null,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        },
        '1.5.3. 분쟁광물 관리': {
            avg: 100,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': null,
                'HD_DOM_RI_25': null,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': 100,
                'HD_OV_COMM_PROD_25': null,
                'HD_OV_RI_25': null,
                'HD_OV_SALES_25': null
            }
        },
        '1.6.1. 기숙사 내 인권 및 안전 관리': {
            avg: 92.7,
            tier_avg: {
                'HD_DOM_HQ_25': null,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': null,
                'HD_OV_PROD_25': 80,
                'HD_OV_COMM_PROD_25': 90,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': null
            }
        },
        '1.6.2. 식당 내 인권 및 위생 관리': {
            avg: 100,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 100,
                'HD_OV_PROD_25': 100,
                'HD_OV_COMM_PROD_25': 100,
                'HD_OV_RI_25': 100,
                'HD_OV_SALES_25': 100
            }
        },
        '2.1.1. 윤리 정책 및 관리 시스템': {
            avg: 78.5,
            tier_avg: {
                'HD_DOM_HQ_25': 80,
                'HD_DOM_PROD_25': 80,
                'HD_DOM_RI_25': 80,
                'HD_OV_HQ_25': 68.3,
                'HD_OV_PROD_25': 92,
                'HD_OV_COMM_PROD_25': 86.7,
                'HD_OV_RI_25': 45,
                'HD_OV_SALES_25': 78.9
            }
        },
        '2.1.2. 윤리신고 매커니즘': {
            avg: 83.4,
            tier_avg: {
                'HD_DOM_HQ_25': 100,
                'HD_DOM_PROD_25': 100,
                'HD_DOM_RI_25': 100,
                'HD_OV_HQ_25': 66.7,
                'HD_OV_PROD_25': 86,
                'HD_OV_COMM_PROD_25': 73.3,
                'HD_OV_RI_25': 58,
                'HD_OV_SALES_25': 81.1
            }
        }
    }
};

const business_site_category = {
    'D4G2KA': {
        'business_type_ko': '생산법인',
        'country_ko': '한국',
        'business_type_en': 'Production',
        'country_en': 'Republic of Korea'
    },
    '8MZ0RW': {
        'business_type_ko': '생산법인',
        'country_ko': '한국',
        'business_type_en': 'Production',
        'country_en': 'Republic of Korea'
    },
    'NU9QF6': {
        'business_type_ko': '생산법인',
        'country_ko': '한국',
        'business_type_en': 'Production',
        'country_en': 'Republic of Korea'
    },
    'JW7BXP': {
        'business_type_ko': '상용생산법인',
        'country_ko': '중국',
        'business_type_en': 'Commercial Production',
        'country_en': 'China'
    },
    'C5H2VL': {
        'business_type_ko': '상용생산법인',
        'country_ko': '중국',
        'business_type_en': 'Commercial Production',
        'country_en': 'China'
    },
    '09RYGD': {
        'business_type_ko': '생산법인',
        'country_ko': '중국',
        'business_type_en': 'Production',
        'country_en': 'China'
    },
    'X7PQRO': {
        'business_type_ko': '생산법인',
        'country_ko': '베트남',
        'business_type_en': 'Production',
        'country_en': 'Vietnam'
    },
    '4TDS8B': {
        'business_type_ko': '상용생산법인',
        'country_ko': '베트남',
        'business_type_en': 'Commercial Production',
        'country_en': 'Vietnam'
    },
    'U2KMZF': {
        'business_type_ko': '생산법인',
        'country_ko': '인도네시아',
        'business_type_en': 'Production',
        'country_en': 'Indonesia'
    },
    'ZF6CPQ': {
        'business_type_ko': '생산법인',
        'country_ko': '미국',
        'business_type_en': 'Production',
        'country_en': 'United States'
    },
    'QY3NVJ': {
        'business_type_ko': '생산법인',
        'country_ko': '미국',
        'business_type_en': 'Production',
        'country_en': 'United States'
    },
    'H8XR4W': {
        'business_type_ko': '상용생산법인',
        'country_ko': '멕시코',
        'business_type_en': 'Commercial Production',
        'country_en': 'Mexico'
    },
    'V0DZBK': {
        'business_type_ko': '생산법인',
        'country_ko': '브라질',
        'business_type_en': 'Production',
        'country_en': 'Brazil'
    },
    'F6YQTR': {
        'business_type_ko': '생산법인',
        'country_ko': '체코',
        'business_type_en': 'Production',
        'country_en': 'Czechia'
    },
    'R2S7PD': {
        'business_type_ko': '생산법인',
        'country_ko': '튀르키예',
        'business_type_en': 'Production',
        'country_en': 'Türkiye'
    },
    'O3L6TX': {
        'business_type_ko': '생산법인',
        'country_ko': '인도',
        'business_type_en': 'Production',
        'country_en': 'India'
    },
    'E4WU5G': {
        'business_type_ko': '생산법인',
        'country_ko': '싱가포르',
        'business_type_en': 'Production',
        'country_en': 'Singapore'
    },
    'GJ9VNQ': {
        'business_type_ko': '본사',
        'country_ko': '한국',
        'business_type_en': 'Headquarter',
        'country_en': 'Republic of Korea'
    },
    'K0C4ZP': {
        'business_type_ko': '권역본부',
        'country_ko': '중국',
        'business_type_en': 'Regional Headquarter',
        'country_en': 'China'
    },
    'P8V5DS': {
        'business_type_ko': '권역본부',
        'country_ko': '독일',
        'business_type_en': 'Regional Headquarter',
        'country_en': 'Germany'
    },
    'S3Q2RM': {
        'business_type_ko': '권역본부',
        'country_ko': '아랍에미레이트',
        'business_type_en': 'Regional Headquarter',
        'country_en': 'United Arab Emirates'
    },
    'M9LD5W': {
        'business_type_ko': '연구소',
        'country_ko': '한국',
        'business_type_en': 'Research Institutes',
        'country_en': 'Republic of Korea'
    },
    '7ZKP0D': {
        'business_type_ko': '연구소',
        'country_ko': '미국',
        'business_type_en': 'Research Institutes',
        'country_en': 'United States'
    },
    'R8QX9V': {
        'business_type_ko': '연구소',
        'country_ko': '독일',
        'business_type_en': 'Research Institutes',
        'country_en': 'Germany'
    },
    'B2G5ZK': {
        'business_type_ko': '연구소',
        'country_ko': '인도',
        'business_type_en': 'Research Institutes',
        'country_en': 'India'
    },
    'Y0MT4N': {
        'business_type_ko': '연구소',
        'country_ko': '중국',
        'business_type_en': 'Research Institutes',
        'country_en': 'China'
    },
    'T3DRV8': {
        'business_type_ko': '연구소',
        'country_ko': '중국',
        'business_type_en': 'Research Institutes',
        'country_en': 'China'
    },
    'W5PX2Q': {
        'business_type_ko': '판매법인',
        'country_ko': '독일',
        'business_type_en': 'Sales',
        'country_en': 'China'
    },
    'C9G3RJ': {
        'business_type_ko': '판매법인',
        'country_ko': '중국',
        'business_type_en': 'Sales',
        'country_en': 'China'
    },
    'L7P8VX': {
        'business_type_ko': '판매법인',
        'country_ko': '중국',
        'business_type_en': 'Sales',
        'country_en': 'China'
    },
    'D0R5WY': {
        'business_type_ko': '판매법인',
        'country_ko': '인도네시아',
        'business_type_en': 'Sales',
        'country_en': 'Indonesia'
    },
    'Q2Z8MX': {
        'business_type_ko': '판매법인',
        'country_ko': '필리핀',
        'business_type_en': 'Sales',
        'country_en': 'Philippines'
    },
    'V6R3YP': {
        'business_type_ko': '판매법인',
        'country_ko': '태국',
        'business_type_en': 'Sales',
        'country_en': 'Thailand'
    },
    'S4TK0Q': {
        'business_type_ko': '판매법인',
        'country_ko': '호주',
        'business_type_en': 'Sales',
        'country_en': 'Australia'
    },
    'Z7BV2M': {
        'business_type_ko': '판매법인',
        'country_ko': '미국',
        'business_type_en': 'Sales',
        'country_en': 'United States'
    },
    'X3C5QW': {
        'business_type_ko': '판매법인',
        'country_ko': '캐나다',
        'business_type_en': 'Sales',
        'country_en': 'Canada'
    },
    'N6D4RJ': {
        'business_type_ko': '판매법인',
        'country_ko': '멕시코',
        'business_type_en': 'Sales',
        'country_en': 'Mexico'
    },
    'J2H8YT': {
        'business_type_ko': '판매법인',
        'country_ko': '미국',
        'business_type_en': 'Sales',
        'country_en': 'United States'
    },
    'G0Z5PK': {
        'business_type_ko': '판매법인',
        'country_ko': '독일',
        'business_type_en': 'Sales',
        'country_en': 'Germany'
    },
    'U9M7HQ': {
        'business_type_ko': '판매법인',
        'country_ko': '영국',
        'business_type_en': 'Sales',
        'country_en': 'United Kingdom'
    },
    'E2S6XV': {
        'business_type_ko': '판매법인',
        'country_ko': '이탈리아',
        'business_type_en': 'Sales',
        'country_en': 'Italy'
    },
    'P3L4DZ': {
        'business_type_ko': '판매법인',
        'country_ko': '스페인',
        'business_type_en': 'Sales',
        'country_en': 'Spain'
    },
    'W0Y8FQ': {
        'business_type_ko': '판매법인',
        'country_ko': '프랑스',
        'business_type_en': 'Sales',
        'country_en': 'France'
    },
    'K2N3VM': {
        'business_type_ko': '판매법인',
        'country_ko': '체코',
        'business_type_en': 'Sales',
        'country_en': 'Czechia'
    },
    'R0X9TS': {
        'business_type_ko': '판매법인',
        'country_ko': '폴란드',
        'business_type_en': 'Sales',
        'country_en': 'Poland'
    },
    'T6P4RW': {
        'business_type_ko': '판매법인',
        'country_ko': '네덜란드',
        'business_type_en': 'Sales',
        'country_en': 'Netherland'
    },
    'M5Z8QC': {
        'business_type_ko': '판매법인',
        'country_ko': '독일',
        'business_type_en': 'Sales',
        'country_en': 'Germany'
    },
    'Y3D7WP': {
        'business_type_ko': '판매법인',
        'country_ko': '스위스',
        'business_type_en': 'Sales',
        'country_en': 'Switzerland'
    }
};

export {benchmark_score, business_site_category};
